import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@mui/material';

const SettingLocationBehaviorSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
  shouldShowOption,
}) => {
  if (!shouldShowOption('Add Setting/Location')) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint.selectedOptions.includes(
              'Add Setting/Location'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Setting/Location'
          />
        }
        label='Add Setting/Location'
      />
      {dataPoint.selectedOptions.includes('Add Setting/Location') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField
              fullWidth
              margin='dense'
              value={dataPoint.settingLocation}
              className='input-height'
              onChange={(e) =>
                handleFieldChange(index, 'settingLocation', e.target.value)
              }
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default SettingLocationBehaviorSection;
